export default "__VITE_ASSET__58etrh7w__"